import React from 'react';

const Divider = ({ className, id }) => {
  return <hr className={`border-gray-100 dark:border-border my-2 ${className}`} id={id} />;
};

export default Divider;
